function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.001 17.541a.492.492 0 01-.492.492h-7.541a.492.492 0 010-.984h7.541a.492.492 0 01.492.492zM8.453 17.541a.492.492 0 01-.492.492H.492a.492.492 0 010-.984h7.469a.492.492 0 01.492.492zM20.001 2.459a.492.492 0 01-.492.492H8.361a.492.492 0 010-.984h11.148a.492.492 0 01.492.492zM4.787 2.459a.492.492 0 01-.492.492h-3.8a.492.492 0 010-.984h3.8a.492.492 0 01.492.492zM20 10a.492.492 0 01-.492.492h-3.607a.492.492 0 010-.984h3.609A.492.492 0 0120 10zM12.394 10a.492.492 0 01-.492.492H.492a.492.492 0 010-.984H11.9a.492.492 0 01.494.492z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.394 10a2.459 2.459 0 11-2.459-2.459A2.462 2.462 0 0116.394 10zm-3.935 0a1.475 1.475 0 101.475-1.475A1.477 1.477 0 0012.46 10zM8.853 2.459A2.459 2.459 0 116.394 0a2.462 2.462 0 012.459 2.459zm-3.935 0A1.475 1.475 0 106.393.984a1.477 1.477 0 00-1.474 1.475zM12.459 17.542A2.459 2.459 0 1110 15.083a2.462 2.462 0 012.459 2.459zm-3.935 0a1.475 1.475 0 101.475-1.475 1.478 1.478 0 00-1.474 1.475z"
});

var SvgFilters = function SvgFilters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 20.001 20.001",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFilters, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Filters.29e13ff6.svg";
export { ForwardRef as ReactComponent };